export const PUBLIC_ROUTE_BYPASS_PATHS = ['/register', '/signup'] as const

export function isBypassedPath(pathname: string): boolean {
  return PUBLIC_ROUTE_BYPASS_PATHS.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  )
}
